import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { Row, Table } from '@occc/ui-design-system';
import { StoredValueExpirationScheduleFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/design-system';

import {
  makeStoredValueExpirationFields,
  storedValueExpirationTableMessages,
} from './stored-value-expiration-table.utils';

const headers = [
  { label: storedValueExpirationTableMessages.expirationDate },
  { label: storedValueExpirationTableMessages.dollarAmount, align: 'right' as const },
];

type StoredValueExpirationTableProps = {
  rows?: StoredValueExpirationScheduleFragment[] | null;
  paginationProps?: IPaginationProps;
  loading?: boolean;
  error?: ApolloError;
};

export const StoredValueExpirationTable = (props: StoredValueExpirationTableProps) => {
  const { rows = [], paginationProps, loading = false, error } = props;

  const tableRows = useMemo<Row[] | null | undefined>(() => {
    return rows?.map((row) => ({
      key: `${row.expirationDate}-${row.storedValue}`,
      fields: makeStoredValueExpirationFields(row),
    }));
  }, [rows]);

  return (
    <Table
      headers={headers}
      rows={tableRows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};
